// extracted by mini-css-extract-plugin
module.exports = {"news":"NewsSection_news___Ti3w","title":"NewsSection_title__cuQOD","common-center-style":"NewsSection_common-center-style__hBWAa"};